module.exports = __webpack_public_path__ + "img/dynamic-28.a3c435f1.png";